export function LogoMark({ size = 30 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none" aria-hidden="true" data-testid="logo-mark">
      <path d="M24 6 L42 24 L24 42 L6 24 Z" stroke="#C9A84C" strokeWidth="2.4" strokeLinejoin="round" />
      <line x1="24" y1="15" x2="24" y2="33" stroke="currentColor" strokeWidth="2.4" />
      <circle cx="24" cy="24" r="2.4" fill="#C9A84C" />
    </svg>
  );
}

export default function Logo({ tone = "ink", size = "text-3xl sm:text-4xl" }) {
  return (
    <span className={`inline-flex items-center gap-3 ${tone === "cream" ? "text-cream" : "text-ink"}`}>
      <LogoMark size={30} />
      <span className={`font-serif ${size} font-semibold tracking-tight leading-none`}>
        Liberty <em className="italic text-gold">CP</em>
      </span>
    </span>
  );
}
